import React from 'react'
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { toastr } from 'react-redux-toastr';
import api from '../../api';
import 'bootstrap/dist/css/bootstrap.min.css';
import ContainerLoader from '../loader/container-loader';
import DataTables from '../DataTables/DataTable';
import styles from '../wallOfFrame/wallOfFrame.module.css'
import { GrEdit } from "react-icons/gr";
import { MdDelete } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import { useSelector } from 'react-redux';

const ManageHubSpoc = () => {

    const [data, setData] = useState([])
    const [hubs, setHubs] = useState([]);
    const [isfetchingHubSpoc, setIsfetchingHubSpoc] = useState(false);
    const [isfetchingHubs, setIsfetchingHubs] = useState(false);
    const [currentId, setCurrentId] = useState(null);
    const navigate = useNavigate()
    const authState = useSelector((state) => state.authUser);
    // const role_id = authState?.profile?.role?.role_id;
    const userRoles = authState?.userRoles || [];
    const hasRole = (roleId) => userRoles.some(role => role.role_id === roleId);


    const fetchHubSpoc = async () => {
        try {
            const response = await api.hubspoc.getDetails({
                resource: `api/hubspoc`,
            });
            // setHubSpocs(response.data.data.res);
        } catch (error) {
            console.error(error.message);
        } finally {
        }
    };


    const fetchHubsSpoc = async () => {
        try {
            setIsfetchingHubSpoc(true);
            const request = { resource: 'api/hubspoc' };
            const response = await api.hubspoc.getDetails(request)
            setData(response.data.data.res);
        } catch (error) {
            console.log(error.message);
        } finally {
            setIsfetchingHubSpoc(false);
        }
    }

    const fetchHubsDetails = async () => {
        try {
            setIsfetchingHubs(true);
            const request = { resource: 'api/hubs' };
            const response = await api.hubs.getDetails(request);
            setHubs(response.data.data);
        } catch (error) {
            console.log(error.message);
        } finally {
            setIsfetchingHubs(false);
        }
    }

    const getHubNameById = (id) => {
        const hubName = hubs?.find(item => item?.id === id);
        return hubName ? hubName?.hubname : 'Unknown';
    };

    // const enrichedData = data.map(item => ({
    //     ...item,
    //     industry_title: hubs.find(ind => ind.id === item.industry_type_id)?.industry_title || 'Unknown'
    // }));

    const getStatusFromRow = (row) => {
        const isActive = row.isactive ? "Active" : "Inactive";

        // Concatenate the statuses with a comma
        const status = [isActive].filter(Boolean).join(", ");
        return status || "Unknown";
    };


    const columns = [
        
        {
            text: 'Hub Name',
            sort: true,
            formatter: (cellContent, row) => getHubNameById(row?.hubid),
            sortValue: (cellContent, row) => getHubNameById(row?.hubid)

        },
        {
            dataField: 'spocname',
            text: 'SPOC Name',
            sort: true,
        },
        {
            dataField: 'spocemail',
            text: 'SPOC Email',
            sort: true,
        },
        {
            dataField: 'action',
            text: 'Actions',
            formatter: (cell, row) => (
                <>
                    <GrEdit size={20} title={'Edit'} className='me-1' onClick={() => handleEdit(row)} />
                    <MdDelete size={20} title={'Delete'} className='ms-1' onClick={() => handleDeleteClick(row)} />
                </>
            ),
            sort: false,
        }
    ];

    const handleDeleteClick = async (row) => {
        const confirmDelete = window.confirm('Are you sure you want to delete this record?');
        if (!confirmDelete) return;
        try {
            setIsfetchingHubSpoc(true)
            const request = { resource: `api/hubspoc/${row.id}`, skipData: true  };
            const response = await api.hubspoc.deleteRecord(request)
            if (response.data.status === 200) {
                toastr.success('Record deleted successfully!');
                window.location.reload(); // Refresh the data after deletion
            } else {
                toastr.error('Failed to delete the record.');
            }
        } catch (error) {
            console.log(error.message)
        } finally {
            setIsfetchingHubSpoc(false);
        }
    }

    const handleEdit = (row) => {
        const hasNullField = [
            row.spocname,
            row.spocemail,
        ].some(field => field === null || field === '');

        // If any field is null, show error and return from the function
        if (hasNullField) {
            toastr.error('Missing Required Fields!');
            return;
        }
        setCurrentId(row.id);
        navigate('/hubspocform', { state: { data, hubs, currentId: row.id, intialData: row, isEdit: true } })
    };

    const handleNew = () => {
        navigate('/hubspocform', { state: { data, hubs, currentId, isEdit: false } })
    }

    useEffect(() => {
        if (!hasRole(6) && !hasRole(10)) {
            navigate('/home');
        }
    }, [userRoles, navigate]);

    useEffect(() => {
        fetchHubsSpoc();
        fetchHubsDetails();
    }, [])

    return (
        <div className={styles.fameContainer} style={{ minHeight: '1150px', height: 'auto', overflow: 'auto' }}>
            <div className={`${styles.dataTableWrapper} mx-auto d-flex justify-content-between p-2`}>
                <h4 className="my-4 managePageTitle">Manage Hub SPOC Details</h4>
                {(!isfetchingHubSpoc && !isfetchingHubs) && <div className={`${styles.filtersWrap} d-flex align-items-center  justify-content-end mt-3 mb-1`}>
                    <Button className={styles.addRecords} onClick={handleNew} variant="primary">
                        Add New
                    </Button>
                </div>}
            </div>
            {(isfetchingHubSpoc || isfetchingHubs) && <ContainerLoader />}
            <div className="walloffame_wrap mb-5">
                {data && data?.length > 0 && (!isfetchingHubSpoc && !isfetchingHubs) && (<div className='row'>
                    <div className='col-12'>
                        <div className={`${styles.dataTableWrapper} mx-auto`}>
                            <DataTables records={data} columns={columns} />
                        </div>
                    </div>
                </div>)}

                {data?.length === 0 && (!isfetchingHubSpoc && !isfetchingHubs) && <Alert variant='danger' className='mx-auto' style={{ width: '90%' }}>No Records Found!!!</Alert>}

            </div>
        </div>
    )
}

export default ManageHubSpoc;
